import * as React from "react";
import { FormattedMessage } from "react-intl";
import Popover from "@material-ui/core/Popover";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import NumberFormatter from "@vingle/wtf-sdk/components/numberFormatter";
import CollectionTooltipContainer from "./collectionTooltip";
import { useIntl } from "app/common/intl/helpers";

const styles = require("./collectionClip.scss");

interface IProps {
  postId: Vingle.Id;
  clipState: boolean;
  clipCount: number;
  onClick?: () => void;
}

const CollectionClipTextIconButton: React.FC<IProps> = ({
  postId,
  clipState,
  clipCount,
}) => {
  const intl = useIntl();
  const refWrapper = React.useRef<HTMLDivElement>(null);
  const [open, setOpenState] = React.useState(false);
  const handleClose = React.useCallback(() => {
    setOpenState(false);
  }, []);
  const handleOpen = React.useCallback(() => {
    setOpenState(true);
  }, []);

  const baseIcon = clipState
    ? PACKS.ENGAGE.CARD_DECK_CLIP_ACTIVE
    : PACKS.ENGAGE.CARD_DECK_CLIP_NORMAL;
  const title = intl.formatMessage({ id: "clip" });

  return (
    <div ref={refWrapper} className={styles.container} title={title}>
      <button className={styles.textIconButton} onClick={handleOpen}>
        <span className={styles.iconWrapper}>
          <IconWrapper tagName="span" icon={baseIcon} className={styles.icon} />
        </span>

        <span className={styles.engageCount}>
          {Boolean(clipCount) ? (
            <NumberFormatter num={clipCount} digits={0} />
          ) : (
            <FormattedMessage id="clip" />
          )}
        </span>
      </button>
      <Popover
        open={open}
        anchorEl={refWrapper.current}
        classes={{
          paper: styles.muiPaper,
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        onClose={handleClose}
      >
        <CollectionTooltipContainer postId={postId} onCancel={handleClose} />
      </Popover>
    </div>
  );
};

export default CollectionClipTextIconButton;
